import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import bar from '../../../images/svg/bar2.svg';
import orangeBackground from './orange-background.svg';
import whiteBackground from './white-background.svg';
import { Link } from '@reach/router';
import { getPage } from 'utils/pages';
import i18n from 'i18n';

const useStyles = makeStyles((theme) => {
  const s = (x) => theme.spacing(x);
  const isGerman = i18n.language === 'de';
  
  return {
    subtitle: {
      color: '#ffffff',
      textTransform: 'uppercase',
      fontSize: s(5),
      marginBottom: s(5),
      [theme.breakpoints.down('lg')]: {
        fontSize: s(4),
      },
    },
    titleBlock: {
      backgroundImage: `url(${bar})`,
      backgroundSize: '100% 100%',
      color: 'white',
      padding: `${s(3)}px ${s(3)}px`,
      width: '100%',
      maxWidth: isGerman? '100%' : '750px',
      marginBottom: s(4.5),
      margin: '0 auto'
    },
    mainTitle: {
      fontSize: s(5.3),
      color: '#000000',
      [theme.breakpoints.down('lg')]: {
        fontSize: s(4),
      },
      [theme.breakpoints.down('sm')]: {
        padding: isGerman ? '35px 0' : '10px 0'
      },
    },
    buttonsBlock: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: s(10),
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        gap: s(2),
      },
    },
    repairLink: {
      width: '100%',
      maxWidth: '272px',
      fontSize: s(2.5),
      fontWeight: 700,
      color: '#ffffff',
      backgroundImage: `url(${orangeBackground})`,
      padding: `${s(1.5)}px ${s(0)}px`,
      transition: '0.4s ease-in-out',
      '&:hover': {
        color: '#ffffff',
        scale: 1.1,
      },
    },
    esimateLink: {
      width: '100%',
      maxWidth: '272px',
      fontSize: s(2.5),
      fontWeight: 700,
      color: '#000000',
      background: `url(${whiteBackground})`,
      padding: `${s(1.5)}px ${s(0)}px`,
      transition: '0.4s ease-in-out',
      '&:hover': {
        color: '#000000',
        scale: 1.1,
      },
    },
  };
});

export const BannerSliderItem = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className="container">
      <Box textAlign={'center'}>
        <h2 className={classes.subtitle}>{t('Still in love with your favourites')}</h2>
        <div className={classes.titleBlock}>
          <h1 className={classes.mainTitle}>{t('Let us take cate of them!')}</h1>
        </div>
        <div className={classes.buttonsBlock}>
          <Link to={`${getPage('product')}${getPage('select')}`} className={classes.repairLink}>
            {t('BookRepair')}
          </Link>
          <Link to="/estimate/new" className={classes.esimateLink}>
            {t('GetAnEstimate')}
          </Link>
        </div>
      </Box>
    </div>
  );
};
